import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
enum AccountType { Teacher = 'Teacher', SubAccount = 'SubAccount' }
@Component({
    components: {
        AccountTableComponent: () => import('./list.vue'),
    }
})
export default class ChildaccountsComponent extends Vue {
    childAccountList: Array<any> = [];//子账号管理列表
    editList: Array<any> = [];//删除历史学习任务列表
    listLoading: Boolean = false;
    editLoading: Boolean = false;
    dialogRemark: Boolean = false;
    dialogPassword: Boolean = false;
    btnOpen: Boolean = true;
    btnClose: Boolean = true;
    btnPassword: Boolean = true;
    password: String = '';
    currentPage: number = 1;
    pageSize: number = 10;
    total: number = 10;
    currAccoutType: string = AccountType.SubAccount;
    currAccoutName: string = '';
    showTeacherInfo: boolean = false;
    $refs: {
        addChildAccountForm: Form,
        passwordForm: Form,
        remarkForm: Form,
        multipleTable: Form,
        abc: Vue,
    };
    /**修改密码Begin**/
    passwordForm = {
        password: '',
        chekcPassword: ''
    }

    passwordFormRules: Object = {
        password: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入用户密码'));
                    } else if (!/^[\w]{6,20}$/.test(value)) {
                        callback(new Error('密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        chekcPassword: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入用户密码'));
                    } else if (!/^[\w]{6,20}$/.test(value)) {
                        callback(new Error('密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成'));
                    } else if (value !== this.passwordForm.password) {
                        callback(new Error('两次输入密码不一致!'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ]
    }

    onPasswordSubmit() {

        if (this.editList.length == 0) {
            this.$alert("请选择要修改密码的账号", '提示').catch(() => { });
            return false;
        }
        this.$refs.passwordForm.validate((valid) => {
            if (valid) {

                let para = [];
                let ids = "";

                this.editList.forEach(item => {
                    para.push(item.subUserId);
                });


                ids = para.join(',');
                para = [];
                this.axios.put('/api/accounts/password/' + ids + '?passWord=' + this.passwordForm.chekcPassword).then((data) => {
                    this.dialogPassword = false;
                    this.password = "";
                    if (data == undefined) {
                        this.$message({
                            message: '提交失败',
                            type: 'error'
                        });
                    } else {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }
                });
            } else {
                return;
            }
        })
    }
    /**修改密码End**/

    //子模块回调  / 点击返回
    jumpInfo(row) {

        this.showTeacherInfo = row ? true : false;

        this.currAccoutType = row ? AccountType.Teacher : AccountType.SubAccount;

        this.currAccoutName = row ? row.accountName : '';

        row ? (<any>this.$refs.abc).getInfoList(row, true) : (<any>this.$refs.abc).getList(AccountType.SubAccount, true);
    }

    addAccount() {
        (<any>this.$refs.abc).addAccount();
    }

    //子模块回调方法
    handleSelectionChange(val) {

        this.editList = val;
        let seleList = this.editList;
        let isClose = false;
        let isOpen = false;
        if (seleList.length > 0) {
            this.btnPassword = false;
            seleList.forEach(item => {
                if (item.status == 1) {
                    isOpen = true;
                } else if (item.status == 0) {
                    isClose = true;
                }
            });
            this.btnClose = isClose;
            this.btnOpen = isOpen;

        } else {
            this.btnPassword = true;
            this.btnOpen = true;
            this.btnClose = true;
        }

    }

    goBack() {
        this.showTeacherInfo = true;

        this.currAccoutType = 'Teacher';
        (<any>this.$refs.abc).getList('Teacher');
    }

    formChildAccount = {
        user: '',
        region: '',
        permissions: []//权限列表
    }

    editAccountPassword() {
        if (this.editList.length == 0) {
            this.$alert('请选择要修改密码的账号', '提示').catch(() => { });
            return false;
        }
        this.$refs['passwordForm'] && this.$refs['passwordForm'].resetFields();
        this.passwordForm.password = '';
        this.passwordForm.chekcPassword = '';
        this.dialogPassword = true;
    }

    closeAccount() {
        this.$confirm('冻结子账号将会同时冻结其下属教师账号，请问是否冻结子账号？', '提示', {
            confirmButtonText: '冻结',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.updateAccount("Frozen");
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }

    updateAccount(operate) {
        let selectMsg = "";
        let errorMsg = "";
        let operaName = "";
        let para = [];
        let ids = "";
        switch (operate) {
            case "Frozen":
                selectMsg = "请选择要冻结的账号";
                errorMsg = "包含冻结账号";
                operaName = "冻结";
                break;
            case "Enable":
                selectMsg = "请选择要启动的账号";
                errorMsg = "包含启动账号";
                operaName = "启动";
                break;
            default:
                break;
        }

        if (this.editList.length == 0) {
            this.$alert(selectMsg, '提示').catch(() => { });
            return false;
        }
        //forEach 无法跳出循环，自定义方法或使用try来跳出
        try {
            this.editList.forEach(item => {
                if (item.status == operaName) {
                    throw new Error(errorMsg);
                } else {
                    para.push(item.subUserId);
                }
            });
            
        } catch (e) {
            para = [];
            this.$alert(e.message, '提示').catch(() => { });
            return false;
        }

        ids = para.join(',');
        para = [];

        this.axios.put('/api/accounts/' + ids + '?operation=' + operate).then((data) => {
            if (data.data.stateCode == '412') {
                this.$message({
                    message: data.data.message,
                    type: 'error'
                });
            } else {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                (<any>this.$refs.abc).getList();
            }
           
        });
    }

    openAccount() {
        this.$confirm('解冻子账号后还需要提醒子账号管理员自行解冻下属教师账号', '提示', {
            confirmButtonText: '解冻',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.updateAccount("Enable");
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }

    mounted() {
    }
}